const labels = {
  username: 'Adresse email',
  password: 'Mot de passe',
};

const validate = values => {
  const errors = {};
  Object.keys(values).forEach(k => {
    if (!values[k] && values[k] !== false) {
      errors[k] = `${labels[k] || k} est requis`;
    }
  });
  return errors;
};

export default {validate, validateOnChange: false, validateOnBlur: false};
